import { FunctionComponent, memo } from 'react';
import { StoryCardContentMedia } from '../../../services';
import { FeedCardProps } from '../../../shared';
import { FeedCardPreviewContent } from '../FeedCardPreviewContent';
import { FeedCardPreviewWrapper } from '../FeedCardPreviewWrapper';

export const FeedCardPreviewMedia: FunctionComponent<FeedCardProps> = memo(({ card }) => {
  const { headline, subHeadline, sourceName, text, textHTML } =
    card.content as StoryCardContentMedia;

  return (
    <FeedCardPreviewWrapper card={card}>
      <FeedCardPreviewContent
        source={sourceName}
        title={headline}
        subTitle={subHeadline}
        text={text}
        htmlText={textHTML}
      ></FeedCardPreviewContent>
    </FeedCardPreviewWrapper>
  );
});
